import '@/shared/styles/global.css'

// First-login welcome modal: shown once per browser. The tm-welcome-seen
// localStorage flag is the sole gate - any authenticated user who has not yet
// dismissed it sees it once on this device, independent of any backend signal.
// try/catch mirrors the storage-access pattern used in ThemeContext /
// SelectedOrgContext (Safari private mode).
export const WELCOME_SEEN_KEY = 'tm-welcome-seen'
export const hasSeenWelcome = () => {
  try { return localStorage.getItem(WELCOME_SEEN_KEY) === '1' } catch { return false }
}
export const markWelcomeSeen = () => {
  try { localStorage.setItem(WELCOME_SEEN_KEY, '1') } catch { /* storage unavailable */ }
}
